module.exports = __webpack_public_path__ + "dce058e0e6e172120361266814fc4eb2.png";